import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdoptForm.css';

const emailImg = require('../assets/email.png');
const contactImg = require('../assets/phone.png');
const addressImg = require('../assets/location.png');
const timingImg = require('../assets/time.png');

function AdoptForm({ animal }) {
    const image = require('../assets/poster.jpg');

    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');

    const [date, setDate] = useState('');
    const [contact, setContact] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();
        setDate(`${yyyy}-${mm}-${dd}`);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Thank you for your interest in adopting ' + animal[id].name + '! We will get back to you soon.');
        navigate('/');
    };

    const checkNumerical = (event) => {
        const inputValue = event.target.value;
        if (!isNaN(inputValue)) {
            setContact(inputValue);
            event.target.setCustomValidity('');
        } else {
            event.target.setCustomValidity('Please enter a valid number');
        }
    };

    return (
        <>
            <div className='form-div'>
                {/* <div className='contactDetails'>
                    <h1>Find out More!</h1>
                    <p>Contact us for more information about the adoption process and to schedule a visit.</p>
                        <li>
                        <img src={emailImg}></img><span style={{ fontWeight: 'bold' }}>Email:</span> info@petheaven.sg
                        </li>
                        <li>
                        <img src={contactImg}></img><span style={{ fontWeight: 'bold' }}>Contact:</span> +65 1234 5678
                        </li>
                        <li>
                        <img src={addressImg}></img><span style={{ fontWeight: 'bold' }}>Address:</span>123 Pet Street, Singapore 123456
                        </li>
                        <li>
                        <img src={timingImg}></img><span style={{ fontWeight: 'bold' }}>Adoption Viewing Hours:</span>Mon-Fri, 10:00 AM - 05:00 PM
                        </li>
                </div> */}
                <div className='posterDiv'>
                    <h2>Book Appointment with <span className='animalName'>{animal[id].name}</span>!</h2>
                    <img src={animal[id].imageUrl}></img>
                </div>
                <form className='adoptionform' onSubmit={handleSubmit}>
                    <span className="inlineFormat">
                        <span className='firstName'>
                            <label> First Name: </label>
                            <br />
                            <input type='text' required></input>
                        </span>
                        <span>
                            <label> Last Name: </label>
                            <br />
                            <input type='text'></input>
                        </span>
                    </span>
                    <span className='email'>
                        <label>Email: </label>
                        <br />
                        <input type='email' required></input>
                    </span>
                    <span className='contact'>
                        <label>Contact: </label>
                        <br />
                        <input type='tel'maxLength="8" pattern="[0-9]{8}" value={contact} onChange={checkNumerical} required></input>
                    </span>
                    <span className="inlineFormat">
                        <span className='date'>
                            <label>Date: </label>
                            <br />
                            <input type='date' min={date} required></input>
                        </span>
                        <span className='date'>
                            <label>Select Time: </label>
                            <br />
                            <select required>
                                <option value='10:00 AM'>10:00 AM</option>
                                <option value='11:00 AM'>11:00 AM</option>
                                <option value='12:00 PM'>12:00 PM</option>
                                <option value='01:00 PM'>01:00 PM</option>
                                <option value='02:00 PM'>02:00 PM</option>
                                <option value='03:00 PM'>03:00 PM</option>
                                <option value='04:00 PM'>04:00 PM</option>
                                <option value='05:00 PM'>05:00 PM</option>
                            </select>
                        </span>
                    </span>
                    <button type='submit'> Submit </button>
                </form>
            </div>
        </>
    );
}

export default AdoptForm;